// StringBuilder.js

//=======================================================
//
// StringBuilder acts roughly like the Java or C#
// implementations' append and toString methods. 
//
// 40 msec for one huge string test using this version.
// 440 mse for same test using immutable version.
//
//=======================================================

class StringBuilder {

	static EMPTY_STRING() { return ''; }

	constructor(str) {
		this._list = [ typeof str === 'string' ? str : StringBuilder.EMPTY_STRING() ];
	}

	append(str) {
		this._list.push(str);
		return this;
	}

	reset() {
		this._list.length = 0;
	}

	toString() {
		return this._list.join( StringBuilder.EMPTY_STRING() );
	}
}

export default StringBuilder;

//=======================================================
//
// This eimplementation uses an immutable list to
// hold string fragments. Each append adds a fragment,
// producing a new internal list. The toString joins
// the fragments into a seamless result string.
//
// Why immutable? 
// The main point is that immutable data is less
// sensitive to state. We could stive for immutability
// where we can, in each projecgt.
//
// 440 msec to go one huge string test
//
//=======================================================

// import {List} from 'immutable/dist/immutable.min.js';

// class StringBuilder {

// 	constructor(str:String) {
// 		const emptyStr = '';
// 		this._list = List.of( typeof str === 'string' ? str : emptyStr );
// 	}

// 	append(str:String) {
// 		this._list = this._list.push(str);
// 		return this;
// 	}

// 	toString():String {
// 		const joinChar = '';
// 		return this._list.join(joinChar);
// 	}
// }

// export default StringBuilder;